export const data3 = {
    "code": 200,
    "msg": "查询成功",
    "data": [{
        "companyName": "光明国际",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "汇率风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 3,
        "alertKriCount": 0,
        "nonAlertKriCount": 3,
        "alertStatusKri": "",
        "riskAnalysis": "在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，超出阈值上限（1.2个月）触发预警，较去年同期（个月）变化约\n在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，低于阈值下限（0.47个月）触发预警，较去年同期（个月）变化约\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期下降约，表明企业受到业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期上升约，表明企业平均库存已无法满足原材料生产耗用，导致产不足销风险。\n意大利Salov上季度共产生疑似异常采购金额约0.000欧元，超过阈值设定的金额（336万欧元），因此触发预警。\n\"\"\"原材料采购风险指标（本期指标已预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险，指标包括原材料库存备货月数和疑似异常采购金额。\"\"\"\n本期原材料库存备货月数处于预警状态，原材料库存备货月数=原材料月末库存量/原材料3个月平均生产耗用量，分析其库存量对生产耗用量的覆盖情况，以衡量其原材料安全库存水平。\n\"\"\"原材料采购风险指标（本期指标未预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险.截止最新汇报期间，原材料采购风险指标均处于阈值范围之内。\"\"\"",
        "trendAnalysis": "在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，超出阈值上限（1.2个月）触发预警，较去年同期（个月）变化约\n在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，低于阈值下限（0.47个月）触发预警，较去年同期（个月）变化约\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期下降约，表明企业受到业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期上升约，表明企业平均库存已无法满足原材料生产耗用，导致产不足销风险。\n意大利Salov上季度共产生疑似异常采购金额约0.000欧元，超过阈值设定的金额（336万欧元），因此触发预警。\n\"\"\"原材料采购风险指标（本期指标已预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险，指标包括原材料库存备货月数和疑似异常采购金额。\"\"\"\n本期原材料库存备货月数处于预警状态，原材料库存备货月数=原材料月末库存量在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，较去年同期（个月）变化约此外，Salov的原材料月度平均生产耗用量为升，较去年同期变化约\n欧洲橄榄油原材料价格不断上涨，本期特级初榨橄榄油采购单价为欧元每公斤，较去年同期（约欧元每公斤）增长幅度为。本期初榨橄榄油采购单价为欧元每公斤，较去年同期（约欧元每公斤）增长幅度为。主要原材料价格均上升，企业利润空间收窄。\n原材料月度平均生产耗用量较去年同期下降，表明企业可能存在业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n原材料月度平均生产耗用量较去年同期上升，表明企业可能存在平均库存已无法满足原材料生产耗用，导致产不足销风险。\n结合”带息负债环比变动率“及“未使用授信额度占比”指标持续预警的情况来看，Salov在原材料价格普遍上涨的大背景下通过银行借款保持较高的原材料备货月数，可能导致Salov未来的财务弹性被压缩。",
        "images": [{
            "imgName": "Snipaste_2024-03-22_10-07-40.png_1712736743388.png",
            "filePath": "https://community.gmfintl.com/root/contract/file/Snipaste_2024-03-22_10-07-40.png_1712736743388.png"
        }, {
            "imgName": "Snipaste_2024-03-22_10-08-25.png_1712736743392.png",
            "filePath": "https://community.gmfintl.com/root/contract/file/Snipaste_2024-03-22_10-08-25.png_1712736743392.png"
        }],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        // "deleteTitleJson": ["风险分析", "趋势分析"]
    }, {
        "companyName": "光明国际",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "流动性风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 12,
        "alertKriCount": 1,
        "nonAlertKriCount": 11,
        "alertStatusKri": "EBITDA杠杆倍数",
        "riskAnalysis": "在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，超出阈值上限（1.2个月）触发预警，较去年同期（个月）变化约\n在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，低于阈值下限（0.47个月）触发预警，较去年同期（个月）变化约\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期下降约，表明企业受到业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期上升约，表明企业平均库存已无法满足原材料生产耗用，导致产不足销风险。\n意大利Salov上季度共产生疑似异常采购金额约0.000欧元，超过阈值设定的金额（336万欧元），因此触发预警。\n\"\"\"原材料采购风险指标（本期指标已预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险，指标包括原材料库存备货月数和疑似异常采购金额。\"\"\"\n本期原材料库存备货月数处于预警状态，原材料库存备货月数=原材料月末库存量在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，超出阈值上限（1.2个月）触发预警，较去年同期（个月）变化约\n在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，低于阈值下限（0.47个月）触发预警，较去年同期（个月）变化约\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期下降约，表明企业受到业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期上升约，表明企业平均库存已无法满足原材料生产耗用，导致产不足销风险。\n意大利Salov上季度共产生疑似异常采购金额约0.000欧元，超过阈值设定的金额（336万欧元），因此触发预警。\n\"\"\"原材料采购风险指标（本期指标已预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险，指标包括原材料库存备货月数和疑似异常采购金额。\"\"\"\n本期原材料库存备货月数处于预警状态，原材料库存备货月数=原材料月末库存量/原材料3个月平均生产耗用量，分析其库存量对生产耗用量的覆盖情况，以衡量其原材料安全库存水平。\n\"\"\"原材料采购风险指标（本期指标未预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险.截止最新汇报期间，原材料采购风险指标均处于阈值范围之内。\"\"\"",
        "trendAnalysis": "在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，较去年同期（个月）变化约此外，Salov的原材料月度平均生产耗用量为升，较去年同期变化约\n欧洲橄榄油原材料价格不断上涨，本期特级初榨橄榄油采购单价为欧元每公斤，较去年同期（约欧元每公斤）增长幅度为。本期初榨橄榄油采购单价为欧元每公斤，较去年同期（约欧元每公斤）增长幅度为。主要原材料价格均上升，企业利润空间收窄。\n原材料月度平均生产耗用量较去年同期下降，表明企业可能存在业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n原材料月度平均生产耗用量较去年同期上升，表明企业可能存在平均库存已无法满足原材料生产耗用，导致产不足销风险。\n结合”带息负债环比变动率“及“未使用授信额度占比”指标持续预警的情况来看，Salov在原材料价格普遍上涨的大背景下通过银行借款保持较高的原材料备货月数，可能导致Salov未来的财务弹性被压缩。",
        "images": [{
            "imgName": "Snipaste_2024-03-22_10-08-54.png_1712736787401.png",
            "filePath": "https://community.gmfintl.com/root/contract/file/Snipaste_2024-03-22_10-08-54.png_1712736787401.png"
        }],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明国际",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 6.84,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 693.16,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        // "deleteTitleJson": ["基本信息", "风险分析", "趋势分析"]
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "人力资源管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 7,
        "alertKriCount": 0,
        "nonAlertKriCount": 7,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "供应链风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 3,
        "alertKriCount": 0,
        "nonAlertKriCount": 3,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "廉洁指数",
        "riskCategoryCode": null,
        "subRisk": "廉洁指数",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 9,
        "alertKriCount": 2,
        "nonAlertKriCount": 7,
        "alertStatusKri": "销售折让率 销售费用率",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "光明食品亚太有限公司",
            "subRisk": "廉洁指数",
            "companyCode": null,
            "riskCategory": "廉洁指数",
            "riskCategoryCode": null,
            "kriName": "销售折让率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 3,
            "kriActualValue": 8.27,
            "kriThresholdValue": 8.5,
            "comparisonOperator": "超过",
            "difference": 0.23,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明食品亚太有限公司",
            "subRisk": "廉洁指数",
            "companyCode": null,
            "riskCategory": "廉洁指数",
            "riskCategoryCode": null,
            "kriName": "销售费用率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 3,
            "kriActualValue": 3.21,
            "kriThresholdValue": 4.0,
            "comparisonOperator": "超过",
            "difference": 0.79,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "投资管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 3,
        "alertKriCount": 1,
        "nonAlertKriCount": 2,
        "alertStatusKri": "中高管人员离职率",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "光明食品亚太有限公司",
            "subRisk": "投资管理风险",
            "companyCode": null,
            "riskCategory": "发展风险",
            "riskCategoryCode": null,
            "kriName": "中高管人员离职率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 1,
            "kriActualValue": 5.56,
            "kriThresholdValue": 5.0,
            "comparisonOperator": "超过",
            "difference": 0.56,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "汇率风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 3,
        "alertKriCount": 0,
        "nonAlertKriCount": 3,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "法律纠纷与诉讼风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 5,
        "alertKriCount": 0,
        "nonAlertKriCount": 5,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "流动性风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 8,
        "alertKriCount": 2,
        "nonAlertKriCount": 6,
        "alertStatusKri": "EBITDA杠杆倍数 EBITDA利息保障倍数",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "光明食品亚太有限公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA利息保障倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 52,
            "kriActualValue": 5.61,
            "kriThresholdValue": 600.0,
            "comparisonOperator": "低于",
            "difference": 594.39,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "光明食品亚太有限公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 52,
            "kriActualValue": 3.72,
            "kriThresholdValue": 360.0,
            "comparisonOperator": "超过",
            "difference": 356.28,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "营运资金风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 8,
        "alertKriCount": 0,
        "nonAlertKriCount": 8,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "光明食品亚太有限公司",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "食品安全风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 6,
        "alertKriCount": 0,
        "nonAlertKriCount": 6,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "人力资源管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 9,
        "alertKriCount": 1,
        "nonAlertKriCount": 8,
        "alertStatusKri": "人均产值变化率",
        "riskAnalysis": "截止最新汇报期间，意大利Salov人均成本约为7425.0783061889欧元，上期人均成本约为7974.8221393841欧元，变化率超过阈值设定百分比（20%），从而触发预警。\n截止最新汇报期间，意大利Salov人均净收入约为160912.9362540717欧元，上期人均净收入约为177348.7725769854欧元，变化率超过阈值设定百分比（20%），从而触发预警。\n\"\"\"人员变动概况指标（本期指标已预警）：\n人员变动概况指标反映员工离职情况或变动情况，包括工厂员工/管理岗位人才/办公室员工的离职率和变动率。\"\"\"\n本期管理岗位人才离职率处于预警状态。管理岗位人才离职率=当期关键岗位离职数/（当期关键岗位离职数+期末关键岗位总数）*100%，可能存在管理岗位人力资源供给不足的风险。\n本期办公室人员离职率处于预警状态。办公室人员离职率=当期办公离职人员数量/（当期办公离职人员数量+期末办公员工总数）*100%，可能存在办公室人力资源供给不足的风险。\n本期工厂员工变动率处于预警状态。工厂员工变动率=（本月工厂员工人数-上月工厂员工人数）/上月工厂员工人数*100%，可能存在劳动力成本大幅度上升，员工队伍不稳定的风险。\n本期管理岗位人才变动率处于预警状态。管理岗位人才变动率=（本月关键岗位人数-上月关键岗位人数）/上月关键岗位人数*100%，可能存在劳动力成本大幅度上升，员工队伍不稳定的风险。\n本期办公室人员变动率处于预警状态。办公室人员变动率=（（本月办公员工人数-上月办公员工人数）/上月办公员工人数*100%，可能存在劳动力成本大幅度上升，员工队伍不稳定的风险。\n\"\"\"人员变动概况指标（本期指标未预警）：\n人员变动概况指标反映员工离职情况或变动情况。截止最新汇报期间，人员变动概况指标均处于阈值范围之内。\"\"\"\n\"\"\"人均产值成本指标（本期指标已预警）：\n人员变动概况指标反映在职员工对公司业务的贡献水平，包括人均产值变化率和人均成本变化率。\"\"\"\n本期人均成本变化率处于预警状态。公司人均成本=（应付职工薪酬+员工福利）/公司在职人员，可能存在劳动力成本大幅度上升的风险。\n本期人均产值变化率处于预警状态。人均净收入= 净收入/公司当月平均在职人员，可能存在总收入上升，人均产值下降，经营效益下降的风险。\n\"\"\"人均产值成本指标（本期指标未预警）：\n人员变动概况指标反映在职员工对公司业务的贡献水平，截止最新汇报期间，人均产值成本指标均处于阈值范围之内。\"\"\"",
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "意大利SALOV公司",
            "subRisk": "人力资源管理风险",
            "companyCode": null,
            "riskCategory": "发展风险",
            "riskCategoryCode": null,
            "kriName": "人均产值变化率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 0.0,
            "kriThresholdValue": 20.0,
            "comparisonOperator": "超过",
            "difference": 20.0,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "原材料采购风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 2,
        "alertKriCount": 0,
        "nonAlertKriCount": 2,
        "alertStatusKri": "",
        "riskAnalysis": "在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，超出阈值上限（1.2个月）触发预警，较去年同期（个月）变化约\n在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，低于阈值下限（0.47个月）触发预警，较去年同期（个月）变化约\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期下降约，表明企业受到业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n此外，Salov的原材料月度平均生产耗用量为升，较去年同期上升约，表明企业平均库存已无法满足原材料生产耗用，导致产不足销风险。\n意大利Salov上季度共产生疑似异常采购金额约0.000欧元，超过阈值设定的金额（336万欧元），因此触发预警。\n\"\"\"原材料采购风险指标（本期指标已预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险，指标包括原材料库存备货月数和疑似异常采购金额。\"\"\"\n本期原材料库存备货月数处于预警状态，原材料库存备货月数=原材料月末库存量/原材料3个月平均生产耗用量，分析其库存量对生产耗用量的覆盖情况，以衡量其原材料安全库存水平。\n\"\"\"原材料采购风险指标（本期指标未预警）：\n原材料采购风险主要关注特级初榨橄榄油与混合橄榄油在主要原产地的原材料采购情况，反映是否存在原材料价格波动，从而引起公司经营目标实现的不确定性的风险.截止最新汇报期间，原材料采购风险指标均处于阈值范围之内。\"\"\"",
        "trendAnalysis": "在备货月数及库存消耗量（主要为生产产成品）方面，截止最新汇报期间，意大利Salov的“原材料库存备货月数”指标为0.562个月，较去年同期（个月）变化约此外，Salov的原材料月度平均生产耗用量为升，较去年同期变化约\n欧洲橄榄油原材料价格不断上涨，本期特级初榨橄榄油采购单价为欧元每公斤，较去年同期（约欧元每公斤）增长幅度为。本期初榨橄榄油采购单价为欧元每公斤，较去年同期（约欧元每公斤）增长幅度为。主要原材料价格均上升，企业利润空间收窄。\n原材料月度平均生产耗用量较去年同期下降，表明企业可能存在业务表现不佳的影响，库存消耗变慢，导致库存积压风险。\n原材料月度平均生产耗用量较去年同期上升，表明企业可能存在平均库存已无法满足原材料生产耗用，导致产不足销风险。\n结合”带息负债环比变动率“及“未使用授信额度占比”指标持续预警的情况来看，Salov在原材料价格普遍上涨的大背景下通过银行借款保持较高的原材料备货月数，可能导致Salov未来的财务弹性被压缩。",
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "存货管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 3,
        "alertKriCount": 0,
        "nonAlertKriCount": 3,
        "alertStatusKri": "",
        "riskAnalysis": "截止最新汇报期间，意大利Salov的特级初榨橄榄油存货周转天数为45.7551686665天，高于阈值（73天）从而触发预警。上期值为39.2907156713天。同期值为73.3111058827天。\n从财务数据结构上分析，该指标受到存货销售数量与存货余量共同作用影响。我们从系统后台导出了相关财务数据发现：1）本月特级初榨橄榄油存货量较去年同期变化：0.3595741080495-。本期特级初榨橄榄油存货量：7892392.7600000000升，去年同期特级初榨橄榄油存货量：12323662.8300000000；2）本月特级初榨橄榄油销售量较去年同期变化：0.02612080215363。本期特级初榨橄榄油销售量：5174754.8900000000升，去年同期特级初榨橄榄油销售量：5043026.\n截止最新汇报期间，意大利Salov的初榨橄榄油存货周转天数为59.1966558492天，高于阈值（97天）从而触发预警。上期值为61.0102102637天。同期值为83.5915206569天。\n从财务数据结构上分析，该指标受到存货销售数量与存货余量共同作用影响。我们从系统后台导出了相关财务数据发现：1）本月初榨橄榄油存货量较去年同期变化：0.29922637248397-。本期初榨橄榄油存货量：5683783.9600000000升，去年同期初榨橄榄油存货量：8110727.5400000000；2）本月初榨橄榄油销售量较去年同期变化：0.01043847291819-。本期初榨橄榄油销售量：2880458.6400000000升，去年同期初榨橄榄油销售量：2910843.4000000000升\n截止最新汇报期间，意大利Salov的种子油存货周转天数为9.3796111780天，高于阈值（39.1天）从而触发预警。上期值为20.7999967258天。同期值为44.2807117001天。\n从财务数据结构上分析，该指标受到存货销售数量与存货余量共同作用影响。我们从系统后台导出了相关财务数据发现：1）本月种子油存货量较去年同期变化：0.74511056682193-。本期种子油存货量：1046234.5500000000升，去年同期种子油存货量：4104660.3500000000；2）本月种子油销售量较去年同期变化：0.20332125626665。本期种子油销售量：3346304.6500000000升，去年同期种子油销售量：2780890.5000000000升。\n存货量的上涨及销售量的下降均导致Salov特级初榨橄榄油存货周转天数上升。\n导致Salov特级初榨橄榄油存货周转天数上升的原因为销售量的下降。\n从宏观市场角度上分析，可能的原因为欧洲特级初榨橄榄油原材料市场的供货量减少、采购单价上升。为应对上涨的原材料价格，Salov适当提高了产品售价，但因此损失了部分价格敏感客户，故最近一年特级初榨橄榄油销售量较上年存在下降趋势，存在存货减值风险。\n存货量的上涨及销售量的下降均导致Salov初榨橄榄油存货周转天数上升。\n导致Salov初榨橄榄油存货周转天数上升的原因为销售量的下降。\n从宏观市场角度上分析，可能的原因为欧洲初榨橄榄油原材料市场的供货量减少、采购单价上升。为应对上涨的原材料价格，Salov适当提高了产品售价，但因此损失了部分价格敏感客户，故最近一年初榨橄榄油销售量较上年存在下降趋势，存在存货减值风险。\n存货量的上涨及销售量的下降均导致Salov种子油存货周转天数上升。\n导致Salov种子油存货周转天数上升的原因为销售量的下降。\n从宏观市场角度上分析，可能的原因为欧洲种子油原材料市场的供货量减少、采购单价上升。为应对上涨的原材料价格，Salov适当提高了产品售价，但因此损失了部分价格敏感客户，故最近一年种子油销售量较上年存在下降趋势，存在存货减值风险。\n\"\"\"存货积压情况指标（本期指标未预警）：\n存货管理将主要关注存货积压风险。存货库存量过高会占用大量资金，导致企业资金利用率低等风险。截止最新汇报期间，存货周转周期指标均处于阈值范围之内。\"\"\"",
        "trendAnalysis": "截止最新汇报期间，意大利Salov的特级初榨橄榄油存货周转天数相比去年同期呈上升趋势，本期值为45.7551686665天。上期值为39.2907156713天。同期值为73.3111058827天。从财务数据结构上分析，该指标受到存货销售数量与存货余量共同作用影响。我们从系统后台导出了相关财务数据发现：1）本月特级初榨橄榄油存货量较去年同期变化：0.3595741080495-。本期特级初榨橄榄油存货量：7892392.7600000000升，去年同期特级初榨橄榄油存货量：12323662.830000\n截止最新汇报期间，意大利Salov的初榨橄榄油存货周转天数相比去年同期呈上升趋势，本期值为59.1966558492天，高于阈值（97天）从而触发预警。上期值为61.0102102637天。同期值为83.5915206569天。从财务数据结构上分析，该指标受到存货销售数量与存货余量共同作用影响。我们从系统后台导出了相关财务数据发现：1）本月初榨橄榄油存货量较去年同期变化：0.29922637248397-。本期初榨橄榄油存货量：5683783.9600000000升，去年同期初榨橄榄油存货量：811072\n截止最新汇报期间，意大利Salov的种子油存货周转天数相比去年同期呈上升趋势，本期值为9.3796111780天，高于阈值（39.1天）从而触发预警。上期值为20.7999967258天。同期值为44.2807117001天。从财务数据结构上分析，该指标受到存货销售数量与存货余量共同作用影响。我们从系统后台导出了相关财务数据发现：1）本月种子油存货量较去年同期变化：0.74511056682193-。本期种子油存货量：1046234.5500000000升，去年同期种子油存货量：4104660.35000",
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "应收账款管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 8,
        "alertKriCount": 1,
        "nonAlertKriCount": 7,
        "alertStatusKri": "应收账款环比增长率",
        "riskAnalysis": "本期应收账款环比增长率处于预警状态。截止最新汇报期间，意大利Salov的“应收账款环比增长率”指标为11.079，超出阈值（6%）触发预警。\n本期应收账款周转天数处于预警状态。截止最新汇报期间，意大利Salov的“应收账款周转天数”为55.128天，超出阈值（55.81天）触发预警。上期值为12.873天。同期值为12.873天。\n本期长期应收账款金额处于预警状态，该指标统计了账期超过60天的应收账款金额。截止最新汇报期间，意大利Salov的“长期应收账款金额”为2055502.454欧元，超出阈值（1,610,000欧元）触发预警。上期值为欧元。同期值为欧元。\nSalov本期应收账款余额约为89895504.5100000000欧元。上期值为80929586.2300000000欧元。环比变化。同期值为71569570.7500000000欧元。同比变动0.25605761733593\n本期超信贷额度客户增长比例处于预警状态。截止最新汇报期间，意大利Salov的“超信贷额度客户增长比例”指标为14.667，超出阈值（11%）触发预警。本期超信贷额度客户数量为86.0000000000个，上期数量为75.0000000000个。\n本期超出信贷额度的客户应收账款超出部分处于预警状态。截止最新汇报期间，意大利Salov的“超出信贷额度的客户应收账款超出部分”指标为欧元，超出阈值（2,830,000欧元）触发预警。\n本期超出信贷额度的应收账款总金额增长率处于预警状态。截止最新汇报期间，意大利Salov的“超出信贷额度的应收账款总金额增长率”指标为4.734-，超出阈值（39%）触发预警。本期超信贷额度客户数量为14728153.5200000000欧元，上期数量为15460077.6000000000欧元。\n本期应收账款坏账准备占比处于预警状态。截止最新汇报期间，意大利Salov的“应收账款坏账准备占比”指标为0.376，超出阈值（1%）触发预警。本期应收账款坏账准备金额为欧元，需进一步确认应收账款坏账计提原因。\n本期坏账核销金额处于预警状态。截止最新汇报期间，意大利Salov的“坏账核销金额”指标为0.000欧元，超出阈值（0）触发预警，需进一步确认坏账核销原因及相关涉及客户。\n\"\"\"应收账款总体指标（本期指标已预警）：\n应收账款总体指标主要关注应收账款总额变动、应收账款流动速度及长期应收账款金额，从而评估是否存在应收账款无法及时收回的情况，指标包括应收账款环比增长率、应收账款周转金额和长期应收账款金额。\"\"\"\n\"\"\"应收账款总体指标（本期指标未预警）：\n应收账款总体指标主要关注应收账款总额变动、应收账款流动速度及长期应收账款金额，从而评估是否存在应收账款无法及时收回的情况，截止最新汇报期间，应收账款总体指标均处于阈值范围之内。\"\"\"\n\"\"\"信贷管理监控指标（本期指标已预警）：\n信贷管理监控指标主要关注赊销超出信贷额度的客户数量和应收总额，反映对于赊销相关应收账款的管理情况，指标包括超信贷额度客户增长比例、超出信贷额度的客户应收账款超出部门、超出信贷额度的应收账款总金额增长率。\"\"\"\n\"\"\"信贷管理监控指标（本期指标未预警）：\n信贷管理监控指标主要关注赊销超出信贷额度的客户数量和应收总额，反映对于赊销相关应收账款的管理情况，截止最新汇报期间，信贷管理监控指标均处于阈值范围之内。\"\"\"\n\"\"\"坏账管理监控指标（本期指标已预警）：\n坏账管理监控指标主要关注应收账款坏账准备金额和坏账实际核销金额，反映面临的坏账损失潜在风险和实际财务影响，指标包括应收账款坏账准备占比和坏账核销金额。\"\"\"\n\"\"\"坏账管理监控指标（本期指标未预警）：\n坏账管理监控指标主要关注应收账款坏账准备金额和坏账实际核销金额，反映面临的坏账损失潜在风险和实际财务影响，截止最新汇报期间，坏账管理监控指标均处于阈值范围之内，企业坏账准备风险处于可控范围。\"\"\"",
        "trendAnalysis": "应收账款余额较上月环比上升（），较去年同期同比上升（0.25605761733593）。应收账款余额过高反映应收账款的沉积、坏账风险增加，可能存在应收账款无法及时收回的情况。\nSalov本期销售收入约为33924608.4100000000欧元。上期值为21413710.2200000000欧元。环比变化。销售收入下降的情况下，本期应收账余额仍上涨（），需进一步评估是否应收账款无法及时收回，公司回款存在不确定性。",
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "意大利SALOV公司",
            "subRisk": "应收账款管理风险",
            "companyCode": null,
            "riskCategory": "运营风险",
            "riskCategoryCode": null,
            "kriName": "应收账款环比增长率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 24,
            "kriActualValue": 25.82,
            "kriThresholdValue": 6.0,
            "comparisonOperator": "超过",
            "difference": 19.82,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "廉洁指数",
        "riskCategoryCode": null,
        "subRisk": "廉洁指数",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 11,
        "alertKriCount": 0,
        "nonAlertKriCount": 11,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "投资管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 5,
        "alertKriCount": 0,
        "nonAlertKriCount": 5,
        "alertStatusKri": "",
        "riskAnalysis": "CAPEX上半年预算完成百分比为0.0000000000，超出半年度预算指标（50%）从而触发预警。\nCAPEX上半年预算完成百分比为0.0000000000，低于半年度预算指标（50%）从而触发预警。\nCAPEX全年预算完成百分比为0.0000000000，超出年度预算指标（100%）从而触发预警。\nCAPEX全年预算完成百分比为0.0000000000，低于年度预算指标（50%）从而触发预警。\n截止最新汇报期间，意大利Salov受限固定资产金额为0.0000000000。需进一步了解固定资产受限原因，相关流程是否通过各级相关管理人员批准。\n截止最新汇报期间，意大利Salov处置固定资产原值为330.460，超过阈值设定金额（50万欧元），从而触发预警。\n去年意大利Salov公司股权价值为0.000欧元，低于设定的阈值121,500,000.00欧元（Salov并购时的股权支付对价）。\n\"\"\"关键人员流失相关指标（本期指标已预警）：\n此类指标基于管理岗位人才波动情况出发，指标包括中高管人员离职率，指标用以衡量被投资公司核心人员的变动情况及管理团队的稳定性。\"\"\"\n本期中高管人员离职率处于预警状态。中高管人员离职率=本月中高管人员离职人数/（本月中高管人员在职人数+本月中高管人员离职人数），中高管人员指经理级别及以上的公司人员，中高管的频繁变动可能影响被投资公司的经营与运作。\n\"\"\"关键人员流失相关指标（本期指标未预警）：\n此类指标基于管理岗位人才波动情况出发，指标包括中高管人员离职率，指标用以衡量被投资公司核心人员的变动情况及管理团队的稳定性。\n截止最新汇报期间，中高管人员离职率处于阈值范围之内。\"\"\"\n\"\"\"投资偏离预算相关指标（本期指标已预警）：\nCAPEX投资预算完成度是指实际CAPEX投资金额与CAPEX投资预算金额的比。通过与CAPEX投资计划完成度的差异进行风险监控。\n基于集团的管理规范要求，对CAPEX实际投资完成情况需半年度跟踪，上半年已明显超出预算投资完成情况目标，可能存在投资超支的风险。\"\"\"\n\"\"\"投资偏离预算相关指标（本期指标已预警）：\nCAPEX投资预算完成度是指实际CAPEX投资金额与CAPEX投资预算金额的比。通过与CAPEX投资计划完成度的差异进行风险监控。\n基于集团的管理规范要求，对CAPEX实际投资完成情况需半年度跟踪，全年已明显超出预算投资完成情况目标，可能存在投资超支的风险。\"\"\"\n\"\"\"投资偏离预算相关指标（本期指标未预警）：\nCAPEX投资预算完成度是指实际CAPEX投资金额与CAPEX投资预算金额的比。通过与CAPEX投资计划完成度的差异进行风险监控。\n基于集团的管理规范要求，对CAPEX实际投资完成情况需半年度跟踪，截止最新汇报期间，上半年CAPEX投资预算偏离度处于阈值范围之内。\"\"\"\n\"\"\"投资偏离预算相关指标（本期指标未预警）：\nCAPEX投资预算完成度是指实际CAPEX投资金额与CAPEX投资预算金额的比。通过与CAPEX投资计划完成度的差异进行风险监控。\n基于集团的管理规范要求，对CAPEX实际投资完成情况需半年度跟踪，截止最新汇报期间，全年CAPEX投资预算偏离度处于阈值范围之内。\"\"\"\n\"\"\"固定资产管理相关指标（本期指标未预警）：\n此类指标基于受限固定资产金额及固定资产处置金额出发，指标包括受限固定资产占比和固定资产处置原值。截止最新汇报期间，固定资产管理相关指标均处于阈值范围之内。\"\"\"\n\"\"\"企业投资价值相关指标（本期指标已预警）：\n对于投资公司而言，被投资公司的股权价值是作为衡量投资项目的关键，被投资公司股权价值的降低直接影响未来投资项目退出的成功与否，该指标越高股权价值越高，投资风险越低，反之则风险越高。\"\"\"",
        "trendAnalysis": "根据意大利Salov公司EBITDA数据，去年EBITDA为欧元，前年EBITDA为欧元，EBITDA同比变动，可能是股权价值下降的主要因素。",
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "汇率风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 2,
        "alertKriCount": 1,
        "nonAlertKriCount": 1,
        "alertStatusKri": "外汇套期保值覆盖率",
        "riskAnalysis": "当前Salov的套期保值覆盖率超出阈值上限水平（80%）的月份。未来3月套期保值覆盖率最大值为：51.520\n当前Salov的套期保值覆盖率低于阈值下限水平（50%）的月份。未来3月套期保值覆盖率最小值为：27.560\n当前Salov的外汇套期保值最大向前滚动月数高于阈值上限水平（3个月）。外汇套期保值最大向前滚动月数最大值为：3.000\n\"\"\"外汇套保情况相关指标（本期指标已预警）：\n此类指标基于外币预测收入敞口可能产生的汇兑损失出发，指标包括外汇套期保值覆盖率和外汇套期保值最大向前滚动月数。\"\"\"\n\"\"\"外汇套保情况相关指标（本期指标未预警）：\n此类指标基于外币预测收入敞口可能产生的汇兑损失出发，指标包括外汇套期保值覆盖率和外汇套期保值最大向前滚动月数。\n当前Salov的套期保值覆盖率没有超出阈值范围水平的月份。\"\"\"",
        "trendAnalysis": "当前Salov的套期保值覆盖率没有超出阈值范围水平的月份。未来3月套期保值覆盖率最大值为：51.520。未来3月套期保值覆盖率最小值为：27.560。外汇套期保值最大向前滚动月数最大值为：3.000\n过高的套期保值覆盖率可能会增加成本，进一步影响公司的竞争力和盈利能力。因此，公司需要仔细评估风险和收益，并在保值策略中找到平衡点。\n过低的套期保值覆盖率可能使公司暴露于汇率波动的风险中，导致未来现金流波动不确定性增加，减少出口的收入，进一步影响盈利能力和财务稳定性。",
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "意大利SALOV公司",
            "subRisk": "汇率风险",
            "companyCode": null,
            "riskCategory": "发展风险",
            "riskCategoryCode": null,
            "kriName": "外汇套期保值覆盖率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 94,
            "kriActualValue": 0.0,
            "kriThresholdValue": 80.0,
            "comparisonOperator": "超过",
            "difference": 80.0,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "法律纠纷与诉讼风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 1,
        "alertKriCount": 0,
        "nonAlertKriCount": 1,
        "alertStatusKri": "",
        "riskAnalysis": "截止最新汇报期间，意大利Salov新增诉讼案件金额为3108975.600欧元，超过阈值设定（100,000欧元），从而触发预警，需结合诉讼案件发生明细进一步评估风险程度。\n\"\"\"诉讼案件情况（本期指标已预警）：\n基于法律诉讼风险的性质及金额，光明国际对意大利Salov发生每一笔法律诉讼的金额及处理情况进行实时监控，指标包括新增诉讼案件金额。\"\"\"\n本期新增诉讼案件金额处于预警状态。该指标反映企业面临的潜在法律诉讼和纠纷风险程度。",
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "流动性风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 9,
        "alertKriCount": 6,
        "nonAlertKriCount": 3,
        "alertStatusKri": "速动比率 现金比率 EBITDA利息保障倍数 EBITDA杠杆倍数 EBITDA净负债比 未使用承诺性授信额度百分比",
        "riskAnalysis": "\"\"\"财务流动性相关指标（本期指标未预警）：\n此类指标基于短期偿债考量因素出发，反映资产的流动性情况，包括常见的财务分析指标：流动比率、速动比率及流动比率。\n截止最新汇报期间，现金比率、速动比率与流动比率均处于阈值范围之内。\"\"\"\n\"\"\"债务评级相关指标（本期指标已预警）：\n此类指标基于短期偿债考量因素出发，包括常见的财务分析指标：EBITDA杠杆倍数、EBITDA利息保障倍数、EBITDA净负债比、带息负债环比变动率和资产负债率。举债情况将通过资产负债率与EBITDA杠杆倍数反映出其流动性风险程度。\"\"\"\n本期带息负债环比变动率处于预警状态。带息负债环比变动率=（当月带息负债/上月带息负债-1）*100%，带息负债=短期借款+长期借款+其他流动性负债。过高可能意味着企业带息负债金额持续上升，需偿还的利息增加。\n本期EBITDA利息保障倍数处于预警状态。EBITDA利息保障倍数=累计12个月EBITDA/累计12个月利息费用。过高带来的主要风险是未能有效利用账面现金，从而在高息环境下降低财务费用，影响企业盈利水平。\n本期EBITDA杠杆倍数处于预警状态。EBITDA杠杆倍数=带息负债/累计12个月EBITDA，净负债=带息负债-货币资金。过高可能意味着企业负债水平较高而货币资金水平处于低位，财务弹性被压缩，偿债能力下降。\n本期EBITDA净负债比处于预警状态。EBITDA净负债比=净负债/累计12个月EBITDA，带息负债=短期借款+长期借款+其他流动性负债。过高可能意味着企业当前处于高息环境下，融资成本较高。\n本期资产负债率处于预警状态。资产负债率=总负债/总资产。过高可能意味着债权人向企业提供信贷资金的风险程度上升，企业偿债能力下降。\n\"\"\"债务评级相关指标（本期指标未预警）：\n此类指标基于短期偿债考量因素出发，包括常见的财务分析指标：EBITDA杠杆倍数、EBITDA利息保障倍数、EBITDA净负债比、带息负债环比变动率和资产负债率。\n截止最新汇报期间，债务评级相关指标均处于阈值范围之内。\"\"\"\n\"\"\"还本能力指标（本期指标未预警）：\n此类指标基于短期偿债考量因素出发，包括常见的财务分析指标：未使用承诺性授信额度百分比。\n截止最新汇报期间，未使用承诺性授信额度百分比处于阈值范围之内。\"\"\"",
        "trendAnalysis": "截止最新汇报期间，意大利Salov账面本期值是：。上期值是：。同期值是：\n从带息负债分析债务评级相关指标趋势：带息负债_无量纲本期值是：139446560.8400000000。上期值是：138791432.4700000000。同期值是：130085617.7300000000\n从企业盈利能力分析债务评级相关指标趋势：本期值是：。上期值是：。同期值是：。营业收入本期值是：33924608.4100000000。上期值是：21413710.2200000000。同期值是：14231510.4800000000。毛利率本期值是：833.0513505817。上期值是：847.1349194493。同期值是：1066.7892408595\n从利息费用分析债务评级相关指标趋势：本期值是：。上期值是：。同期值是：\n截止最新汇报期间，企业总授信额度中，剩余商业活动未使用承诺性授信额度百分比本期值是：27.310。上期值是：40.404。同期值是：40.404\n毛利率较去年同期呈下滑趋势，可能由于1）近年来欧洲橄榄油原材料价格上涨，导致Salov产品单位成本上升；2）为缓解原材料上升带来的影响，Salov提高了产品单价。但受限于价格敏感度，产品提价幅度无法弥补原材料价格上升带来的成本增加。Salov产品毛利率表现不佳。\n尽管Salov的未使用授信额度未预警，但该指标趋近阈值设定下限，表明当前在信贷机构尚可提取的现金额度接近预警临界水平，Salov整体偿债能力愈发下降。",
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "意大利SALOV公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA净负债比",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 24,
            "kriActualValue": 7.43,
            "kriThresholdValue": 700.0,
            "comparisonOperator": "超过",
            "difference": 692.57,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "意大利SALOV公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA利息保障倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 157,
            "kriActualValue": 2.2,
            "kriThresholdValue": 300.0,
            "comparisonOperator": "低于",
            "difference": 297.8,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "意大利SALOV公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "EBITDA杠杆倍数",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 24,
            "kriActualValue": 8.95,
            "kriThresholdValue": 800.0,
            "comparisonOperator": "超过",
            "difference": 791.05,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "意大利SALOV公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "未使用承诺性授信额度百分比",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 24,
            "kriActualValue": 27.17,
            "kriThresholdValue": 30.0,
            "comparisonOperator": "低于",
            "difference": 2.83,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "意大利SALOV公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "现金比率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 10.03,
            "kriThresholdValue": 7.5,
            "comparisonOperator": "低于",
            "difference": 2.53,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "意大利SALOV公司",
            "subRisk": "流动性风险",
            "companyCode": null,
            "riskCategory": "核心风险",
            "riskCategoryCode": null,
            "kriName": "速动比率",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 5,
            "kriActualValue": 44.29,
            "kriThresholdValue": 42.9,
            "comparisonOperator": "低于",
            "difference": 1.39,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "意大利SALOV公司",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "食品安全风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 6,
        "alertKriCount": 0,
        "nonAlertKriCount": 6,
        "alertStatusKri": "",
        "riskAnalysis": "\"\"\"食品安全检测相关指标（本期指标已预警）：\n此类指标反应产品接受相关检测的结果，将直观呈现食品质量及安全情况。包括内部进行核心指标检测，和外部进行的监管部门及独立第三方开展的飞检。\"\"\"\n本期核心指标检测结果处于预警状态。产品食品安全相关核心指标检测合格率指的是产品最关键阶段食品安全相关指标的检测的合格率，反映每个月检测的第一个批次入库存货的检测结果。指标预警可能意味着初榨橄榄油的原材料收货检测结果不合格，或精炼橄榄油完成加工后检测结果不合格，食品质量及安全风险较高。",
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "人力资源管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 9,
        "alertKriCount": 1,
        "nonAlertKriCount": 8,
        "alertStatusKri": "管理岗位人才变动率",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "香港万安公司",
            "subRisk": "人力资源管理风险",
            "companyCode": null,
            "riskCategory": "发展风险",
            "riskCategoryCode": null,
            "kriName": "管理岗位人才变动率",
            "kriStatus": "1",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 40,
            "kriActualValue": 5.88,
            "kriThresholdValue": 5.0,
            "comparisonOperator": "超过",
            "difference": 0.88,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "原材料采购风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 1,
        "alertKriCount": 0,
        "nonAlertKriCount": 1,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "存货管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 6,
        "alertKriCount": 0,
        "nonAlertKriCount": 6,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "运营风险",
        "riskCategoryCode": null,
        "subRisk": "应收账款管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 8,
        "alertKriCount": 1,
        "nonAlertKriCount": 7,
        "alertStatusKri": "超出信贷额度的客户应收账款超出部分",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "香港万安公司",
            "subRisk": "应收账款管理风险",
            "companyCode": null,
            "riskCategory": "运营风险",
            "riskCategoryCode": null,
            "kriName": "超出信贷额度的客户应收账款超出部分",
            "kriStatus": "1",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 40,
            "kriActualValue": 4.699263983E7,
            "kriThresholdValue": 3.0841254E9,
            "comparisonOperator": "超过",
            "difference": 3.03713276017E9,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "廉洁指数",
        "riskCategoryCode": null,
        "subRisk": "廉洁指数",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 11,
        "alertKriCount": 3,
        "nonAlertKriCount": 8,
        "alertStatusKri": "超信用额度的应收账款金额 大额资金支付金额 大额资金支付频次",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [{
            "companyName": "香港万安公司",
            "subRisk": "廉洁指数",
            "companyCode": null,
            "riskCategory": "廉洁指数",
            "riskCategoryCode": null,
            "kriName": "大额资金支付金额",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 62,
            "kriActualValue": 3.2124731197E8,
            "kriThresholdValue": 1.3070207767E8,
            "comparisonOperator": "超过",
            "difference": 1.905452343E8,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "香港万安公司",
            "subRisk": "廉洁指数",
            "companyCode": null,
            "riskCategory": "廉洁指数",
            "riskCategoryCode": null,
            "kriName": "大额资金支付频次",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 62,
            "kriActualValue": 37.0,
            "kriThresholdValue": 13.0,
            "comparisonOperator": "超过",
            "difference": 24.0,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }, {
            "companyName": "香港万安公司",
            "subRisk": "廉洁指数",
            "companyCode": null,
            "riskCategory": "廉洁指数",
            "riskCategoryCode": null,
            "kriName": "超信用额度的应收账款金额",
            "kriStatus": "99",
            "reportTime": "2024-02-01T00:00:00.000+08:00",
            "kriWarningDuration": 821,
            "kriActualValue": 8.610763983E7,
            "kriThresholdValue": 5.97590728E8,
            "comparisonOperator": "超过",
            "difference": 5.1148308817E8,
            "relatedResponse": null,
            "dataversion": "202402",
            "reportVersion": "2024-04-10"
        }],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "投资管理风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 4,
        "alertKriCount": 0,
        "nonAlertKriCount": 4,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "汇率风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 1,
        "alertKriCount": 0,
        "nonAlertKriCount": 1,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "发展风险",
        "riskCategoryCode": null,
        "subRisk": "法律纠纷与诉讼风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 1,
        "alertKriCount": 0,
        "nonAlertKriCount": 1,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "流动性风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 9,
        "alertKriCount": 0,
        "nonAlertKriCount": 9,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }, {
        "companyName": "香港万安公司",
        "companyCode": null,
        "riskCategory": "核心风险",
        "riskCategoryCode": null,
        "subRisk": "食品安全风险",
        "subRiskCode": null,
        "riskStatus": null,
        "kriCount": 7,
        "alertKriCount": 0,
        "nonAlertKriCount": 7,
        "alertStatusKri": "",
        "riskAnalysis": null,
        "trendAnalysis": null,
        "images": [],
        "dataversion": "202402",
        "reportVersion": "2024-04-10",
        "kriDetailList": [],
        "deleteTitleJson": []
    }]
};

export const sortedKeys = ["核心风险", "发展风险", "运营风险", "廉洁指数"];
export const sortedCompanys = ["光明国际", "光明食品亚太有限公司", "意大利SALOV公司", "香港万安公司"];

export const statusMap = {
    "0": "风险未预警",
    "1": "预警已处理",
    "99": "预警未处理"
};